<template>
  <div class="index" v-bind:style="{backgroundImage:'url(' + bg_img + ')'}">
      <h3 ref="title" class="animated zoomIn">我们的<span>故</span>事</h3>
      <div ref="button"  @click="goNext()"  class="button-bg animated bounceInLeft" v-bind:style="{backgroundImage:'url(' + button_img + ')'}">
          点击放送
      </div>
      <img ref="img" class="index-bottom animated fadeInUp" src="https://cdn.hanlandglobal.com/h5-story-bg.png" />
  </div>
</template>

<script>
// @ is an alias to /src
import bg_img from '../assets/image/h5-bg.png'
import button_img from '../assets/image/button-bg.png'

export default {
  name: 'Home',
  data(){
    return {
      bg_img,
      button_img
    }
  },
  mounted(){

  },
  methods:{
      goNext:function(){
          this.$refs.img.className = 'index-bottom animated fadeOutRight'
          this.$refs.title.className = 'animated fadeOutRight'
          this.$refs.button.className = 'button-bg animated fadeOutLeft'
          setTimeout(()=>{
            this.$router.push('/Story2')
          },600)
      }
  }
}
</script>
<style lang='scss' scoped>
.index{
  width: 100%;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: 100% 100vh;
  position: relative;
}
h3{
  font-size: 0.54rem;
  font-family: SourceHan;
  color: #4d372e;
  text-align: center;
  letter-spacing: 1px;
  padding-top:13vh;
  span{
    font-size: 0.72rem;
  }
}
.index-bottom{
  width: 100%;
  height: 3.48rem;
  position: absolute;
  left: 0;
  bottom: 0;
}
.button-bg{
  width: 2rem;
  height: 0.62rem;
  background-repeat: no-repeat;
  background-size: 2rem 0.62rem;
  margin:0 auto;
  color: #f8eed5;
  font-size: 0.32rem;
  line-height: 0.58rem;
  margin-top: 1.34rem;
  font-weight: 700;
  font-family: SourceHan;
}
</style>
